import Mark from "./Mark.ts";
import {Container, Graphics, Sprite, Text} from "pixi.js";
import MarkText from "../components/MarkText.ts";
import IMark from "../interfaces/IMark.ts";
import RhColors from "@/models/RhColors.ts";

export default class SyllableSplitMark extends Mark implements IMark
{
    constructor(targetTextField?:MarkText, color=RhColors.MARK_PRIMARY)
    {
        super(color);
        this.targetTextField = targetTextField;
        this._init();
    }

    private _init():void
    {
        this.strokeThickness = 8;
        this.markHeight = 175;
        if(this.targetTextField)
        {
            this.parentTarget = this.targetTextField;
            const fontSize = Number(this.targetTextField.style.fontSize);
            this.markHeight = this.targetTextField.height+18;
            this.markX = this.targetTextField.width+4;
            this.markY = fontSize*.72;
        }
        this.markWidth = this.strokeThickness;
    }

    private createMark(color:string=this.color, visible:boolean=true):Graphics | Sprite | Text | Container
    {
        let mark = new Graphics();
        mark.moveTo(0, 0);
        mark.lineTo(0, this.markHeight);
        mark.stroke({width:this.strokeThickness, color:color, cap:"round"});
        mark.visible = visible;
        this.addChild(mark);
        //mark.cacheAsBitmap = true;
        return mark;
    }


    public override create():void
    {
        this.createMarks();
    }

    public createMarks():void
    {
        this.mark = this.createMark();
        this.markHighlight = this.createMark(this.highlightColor, false);
    }

}